import { Component, inject, Input } from '@angular/core';
import { InvoicesService } from '@modules/universal-billing/billing/invoice/invoices.service';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { SharedModule } from '@primeng/api';
import { Table } from '@primeng/table';
import { TranslatePipe } from '@ngx-translate/core';
import { PaymentsService } from '@modules/universal-billing/accounting/payments/payments.service';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { Resident } from '@modules/universal-billing/residents/residents.interfaces';
import { idField, ReferenceField } from '@common/references/reference-field';

@Component({
  selector: 'apartment-payments',
  standalone: true,
  imports: [
    SharedModule,
    Table,
    TranslatePipe
  ],
  templateUrl: './apartment-payments.component.html',
  styleUrl: './apartment-payments.component.scss'
})
export class ApartmentPaymentsComponent extends BasicTableComponent<any> {
  @Input() apartmentId: number;
  @Input() period: Date;
  @Input() resident: Resident;

  service = inject(PaymentsService);
  addQueryToUrl = false;

  fields: ReferenceField[] = [];

  constructor() {
    super();
    this.fields = this.service.fields.map(
      (field) => {
        return {
          ...field,
          filter: false,
        };
      }
    ).filter(field => field.fieldName != 'details');
  }

  getAll(params: any): Observable<PageResult<any>> {
    params.apartmentId = this.apartmentId;
    params.period = this.period;
    params.orderType = 'desc';
    return super.getAll(params);
  }

  onAdd() {
    this.modalService.open({
      component: this.service.formComponent,
      title: this.translateService.instant('ADD'),
      componentOptions: {
        _defaultService: this.service,
        residentId: this.resident.id
      },
      modalOptions: this.service?.formModalOptions ?? {}
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData();
      }
    })
  }
}
